/* Component Dependencies */
var sectionDividerImageTextTemplate = require('templates/sectionDividerImageText.hbs');
var AriesComponent = require('libs/aries-component');
var FadeInHandler = require('libs/fade-in-handler');
var $ = require('jquery');

AriesComponent.create({
  type: 'sectionDividerImageText',
  template: {
    'sectionDividerImageText': sectionDividerImageTextTemplate
  },
  events: {
    'click .js-scroll-down': 'scrollDownPage'
  },
  bindEvents: function() {
    var _self = this;
    var img = _self.$el.find('img');
    var imageContainer = _self.$el.find('.m-section-image');
    // for adding image as background image on desktop viewport
    /*$(window).on('load resize', function () {
      var screenSize = $(window).width();
      var attrSource = img.attr('data-src');
      if (screenSize >= 1025) { 
        imageContainer.css('background', 'url(' + attrSource + ') center center / cover fixed');
        img.css('display', 'none');
      } else {
        imageContainer.css('background', 'none');
        img.css('display', 'block');
      }
    }); */
    // for fadeIn effect
    triggerElement = '.tile-section-divider-container .m-section-title-container',
    options = $(triggerElement).data();
    FadeInHandler.init(triggerElement, options);
  },
  scrollDownPage: function() {
    var _self = this;
    var nextTileTop = _self.$el.closest(".mi-sub-section").nextAll('.mi-sub-section').not('.mi-sub-section-blank')[0];
    if ($(nextTileTop).offset()) {
      $('html, body').animate({
        scrollTop: $(nextTileTop).offset().top- $('html').offset().top
      },'slow');
    }
  }
});
